import { Pipe, PipeTransform } from '@angular/core';
import {environment} from '../../../environments/environment';

@Pipe({
  name: 'imagePath'
})
export class ImagePathPipe implements PipeTransform {

  transform(path: string, ...args: unknown[]): string | null {
    if (path) {
      // return environment.storagePath + path;
      return environment.basePathImage + path;
    }
    return null;
  }

}
